log = require 'loglevel'
BaseManager = require 'BaseManager'

class TrackingManager extends BaseManager

  name: "TrackingManager"
  logging: false

  #----------------------

  setup: (gameCode)->
    log.info @name, "setup",gameCode
    @gameCode = gameCode
    @jsErrors()

  #----------------------

  trackPage: (route, title = null) ->
    log.info @name, 'trackPage', title if @logging

    return unless window.ga?

    # GA Page tracking
    window.ga "send",
      hitType: "pageview"
      title: "#{title}"
      page: "#{route}"

  #----------------------

  trackEvent: (label, category='button', action='click', count=0) ->
    log.info @name, 'trackEvent', label, action, category, count if @logging

    return unless window.ga?

    # GA Event tracking
    window.ga 'send',
      hitType: 'event'          # Required.
      eventCategory: category   # Required.
      eventAction: action      # Required.
      eventLabel: label
      eventValue: count

  #----------------------

  trackException: (desc, fatal=false) ->
    log.info @name, 'trackException', desc, fatal if @logging

    return unless window.ga?

    window.ga 'send', 'exception',
      exDescription: desc
      exFatal: fatal
      appName: @gameCode
      appVersion: window.__version

  #----------------------

  jsErrors:->

    window.addEventListener 'error', (err) =>

      log.info @name, 'Javascript error'

      lineAndColumnInfo = if err.colno then ' line:' + err.lineno + ', column:' + err.colno else ' line:' + err.lineno
      location = err.filename + lineAndColumnInfo + ' -> ' +  navigator.userAgent

      @trackEvent('JavaScript Error', err.message, location)
      @trackException 'JSERROR - ' + err.message

  #----------------------

module.exports = TrackingManager.getInstance()


// WEBPACK FOOTER //
// ./coffee/manager/tracking-manager.coffee